import styled from '@emotion/styled';
import { Div } from '../../../layouts';

import {
    SLIDE_IMAGE_MAX_HEIGHT,
    SLIDE_IMAGE_MAX_WIDTH,
    SLIDE_TITLE_WIDTH,
} from './utils/constants';

export const SlideImageContainer = styled(Div)`
    .odf-flex-container-row > &&& {
        text-align: center;
        max-width: ${SLIDE_IMAGE_MAX_WIDTH};
        max-height: ${SLIDE_IMAGE_MAX_HEIGHT};
        overflow: hidden;
    }

    & img {
        max-height: ${SLIDE_IMAGE_MAX_HEIGHT};
        max-width: ${SLIDE_IMAGE_MAX_WIDTH};
    }
`;

export const SlideTitleContainer = styled(Div)`
    .odf-flex-container-row > &&& {
        max-width: ${SLIDE_TITLE_WIDTH};
        overflow: hidden;
        min-width: ${SLIDE_TITLE_WIDTH};
    }
`;
